<template>
  <div>
    <files type="dangerWasterLicenseFiles"></files>
  </div>
</template>

<script>
import files from './files.vue'
export default {
  components: { files },

  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped></style>